<template>
  <div class="mft-input-group">
    <p class="top-label">
      {{ label }}
      <span v-if="required" class="reqstar">*</span>
    </p>
    <p v-if="helper_text">{{ helper_text }}</p>
    <form-datepicker
      small
      v-model="completeDate"
      name="start_date"
      format="DD / MM / YYYY"
      input-class="c-form__input"
      data-vv-as="start_date"
      :error="errors.first('start_date')"
      v-validate="validationObj"
    ></form-datepicker>

    <p v-if="error" class="validation-error">{{error}}</p>
  </div>
</template>

<script>
export default {
  name: "FormDateinput",

  props: {
    value: {
      type: String,
      default: null
    },
    helper_text: {
      type: String,
      default: null
    },
    label: {
      type: String,
      defaul: "Select date"
    },
    required: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ""
    },
    mindate: {
      type: String,
      default: ""
    },
    maxdate: {
      type: String,
      default: ""
    }
  },
  computed: {
    completeDate: {
      get() {
        return `${this.year}-${this.month}-${this.day}`;
      },
      set(newVal, oldVal) {
        const date = this.$dayjs(newVal).format("YYYY-MM-DD");
        const bits = date.split("-");
        this.year = bits[0];
        this.month = bits[1];
        this.day = bits[2];
        this.$emit("input", date);
      }
    }
  },

  watch: {
    completeDate(newValue, oldValue) {
      this.$emit("input", newValue);
    }
  },

  data() {
    return {
      year: null,
      month: null,
      day: null,
      validationObj: ""
    };
  },
  created() {
    if (this.value) {
      const bits = this.value.split("-");
      this.year = bits[0];
      this.month = bits[1];
      this.day = bits[2];
    } else {
      const date = new Date();
      this.year = date.getFullYear();
      this.month = date.getMonth() + 1;
      this.day = date.getDate();
    }

    let validateObj = "date_format:yyyy-MM-dd|";
    if (this.required) {
      validateObj = `${validateObj}required: true|`;
    }
    if (this.mindate && this.maxdate) {
      // americanised obz
      const minDate = this.mindate.split("/");
      const minDateString = `${minDate[2]}-${minDate[1]}-${minDate[0]}`;
      const maxDate = this.maxdate.split("/");
      const maxDateString = `${maxDate[2]}-${maxDate[1]}-${maxDate[0]}`;
      validateObj = `${validateObj}date_between:${this.$dayjs(
        minDateString
      ).format("YYYY-MM-DD")},${this.$dayjs(maxDateString).format(
        "YYYY-MM-DD"
      )},1`;
    }
    this.validationObj = validateObj;
  }
};
</script>

<style lang="scss" scoped>
.mft-input-group {
  .top-label {
    font-size: 1.25rem;
    line-height: 120%;
    margin-top: 0;
  }
  div {
    display: inline-block;
    margin: 0 10px 0 0;
    line-height: 165%;
  }

  label {
    font-size: 16px;
    line-height: 1.2;
    padding-bottom: 0.5rem;
    display: inline-block;
  }

  .reqstar {
    color: red;
  }

  input {
    border: 2px solid #c9ced4;
    border-radius: 4px;
    background: #ffffff;
    font-size: 16px;
    padding: 1em;
    display: block;
    width: auto;
    padding-right: 3em;
    max-width: 100%;
  }

  //https://css-tricks.com/snippets/css/turn-off-number-input-spinners/
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    appearance: none;
    margin: 0;
  }

  input[maxlength="2"] {
    min-width: 100px;
  }
}
</style>